import React from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import ActionButton from 'Common/Buttons/ActionButton'
import RefinerRow from './RefinerRow';
import { fieldShape, selectorShape } from './Refiner.props';
import Panel from 'Common/Layout/Panel';

function RefinerView({
    allFields,
    availableFields,
    disabled,
    isOpen,
    isReadOnly,
    selectors,
    showAdd,
    uniqueDataValues,
    onAddClick,
    onPanelToggleClick,
    onRowFieldChange,
    onRowValueChange,
    onRowRemoveClick,
    onClearAllClick
}) {
    return (
        <Panel
            disabled={disabled}
            open={isOpen}
            renderHeader={RefinerHeader}
            showAdd={showAdd}
            title="Refine"
            variant="collapsable"
            onAddClick={onAddClick}
            onToggle={onPanelToggleClick}            
        >
            <Grid container data-testid="refinement-panel">
                {selectors.map((selector, index) => {
                    const rowField = getSelectedField(allFields, selector);
                    const uniqueFieldValues = selector.field && Array.isArray(uniqueDataValues[selector.field])
                        ? uniqueDataValues[selector.field]
                        : null;
                    return (
                        <Grid item xs={12} key={index}>
                            <RefinerRow
                                selector={selector}
                                fields={availableFields}
                                isReadOnly={isReadOnly}
                                selectedField={rowField}
                                uniqueFieldValues={uniqueFieldValues}
                                value={selector.value}
                                onFieldChange={onRowFieldChange}
                                onOptionChange={onRowValueChange}
                                onRemoveClick={onRowRemoveClick} />
                        </Grid>
                    );
                })}
                {selectors.length > 1 && !isReadOnly && (
                    <Grid item xs={12}>
                        <ActionButton onClick={onClearAllClick} text="Clear All" />
                    </Grid>
                )}
            </Grid>
        </Panel>
    );
}

function RefinerHeader({ showAdd, open, onAddClick }) {
    if (showAdd && open) {
        return (
            <IconButton
                color="primary"
                onClick={onAddClick}
                aria-label="Add a Refinement">
                <AddBoxIcon />
            </IconButton>
        );
    }

    return null;
}

function getSelectedField(allFields, selector) {
    if (selector && selector.field) {
        const selectedField = allFields.find(f => f.name === selector.field);
        if (selectedField) {
            return selectedField;
        }
    }

    return undefined;
}

RefinerView.propTypes = {
    allFields: PropTypes.arrayOf(PropTypes.shape(fieldShape)).isRequired,
    availableFields: PropTypes.arrayOf(PropTypes.shape(fieldShape)).isRequired,
    disabled: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    selectors: PropTypes.arrayOf(PropTypes.shape(selectorShape)).isRequired,
    showAdd: PropTypes.bool.isRequired,
    uniqueDataValues: PropTypes.objectOf(
        PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.bool])),
    onAddClick: PropTypes.func.isRequired,
    onPanelToggleClick: PropTypes.func,
    onRowFieldChange: PropTypes.func.isRequired,
    onRowValueChange: PropTypes.func.isRequired,
    onRowRemoveClick: PropTypes.func.isRequired,
    onClearAllClick: PropTypes.func.isRequired,
};

export default React.memo(RefinerView);